export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M2.158 1.719A7.684 7.684 0 018 2.769a7.684 7.684 0 015.842-1.05l1.375.305A1 1 0 0116 3v10.5a1 1 0 01-1.217.976l-1.375-.305a5.684 5.684 0 00-4.783 1.11 1 1 0 01-1.25 0 5.684 5.684 0 00-4.783-1.11l-1.375.305A1 1 0 010 13.5V3a1 1 0 01.783-.976l1.375-.305zm11.467.976L15 3v10.5l-1.375-.305a6.684 6.684 0 00-5.125.942v-10.5a6.684 6.684 0 015.125-.942zM7.5 3.637a6.684 6.684 0 00-5.125-.942L1 3v10.5l1.375-.305a6.684 6.684 0 015.125.942v-10.5z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};